import ViewIssuesCompletion from "./components/ViewIssuesCompletion";

export default ViewIssuesCompletion;